import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, redirect } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import "../App.css";
import { formatDateText, parseResponseJSON } from "./CommonFunctions";
import { Box } from "@mui/material";
import { DataGrid, GridPagination } from '@mui/x-data-grid';
import { NumericFormat } from 'react-number-format';
import PrintIcon from '@mui/icons-material/Print';
import {
    Dialog, 
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button
} from "@mui/material";

const TenancyDetailsByLTTI = ({
  tenancyDetailsProps,
  longTermTenancyId,
  showTenancyDetailsByLTTIModal,
  setShowTenancyDetailsByLTTIModal
}) => {
    const url = process.env.REACT_APP_SERVER_URL;
    const [tenancyDetails, setTenancyDetails] = useState([]);
    const [totalAmountPaid, setTotalAmountPaid] = useState(0);
    var runningBalance = 0;
    
    const handleCloseTenancyDetailsByLTTIPopup = () => {
        setShowTenancyDetailsByLTTIModal(false);
    };

    const handlePrint = () => {
        const printWindow = window.open('', '', 'height=600,width=800');
        
        let totalAmount = 0;
        let totalCreditCard = 0;
        let totalCash = 0;
        let totalOther = 0;

        const rowsHTML = tenancyDetails.map((row, index) => {
            const amountPaid = row.amountPaid || 0;
            const creditCard = row.creditCardAmount || 0;
            const cash = row.cashAmount || 0;
            const other = row.otherAmount || 0;

            totalAmount += amountPaid;
            totalCreditCard += creditCard;
            totalCash += cash;
            totalOther += other;

            return `
                <tr>
                    <td>${index + 1}</td>
                    <td>${formatDateText(row.actualPaymentDate)}</td>
                    <td style="text-align: right; font-weight: bold;">$${amountPaid.toFixed(2)}</td>
                    <td style="text-align: right;">$${creditCard.toFixed(2)}</td>
                    <td style="text-align: right;">$${cash.toFixed(2)}</td>
                    <td style="text-align: right;">$${other.toFixed(2)}</td>
                </tr>
            `;
        }).join('');

        const htmlContent = `
            <html>
                <head>
                    <title>Tenancy Payment Details</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            padding: 20px;
                        }
                        h2 {
                            text-align: center;
                            margin-bottom: 20px;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-bottom: 20px;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        tr:nth-child(even) {
                            background-color: #f9f9f9;
                        }
                        .totals {
                            margin-top: 20px;
                            padding: 10px;
                            background-color: #f0f0f0;
                            border: 1px solid #ddd;
                        }
                        .totals-row {
                            background-color: #e8e8e8 !important;
                            font-weight: bold;
                        }
                        @media print {
                            body {
                                padding: 10px;
                            }
                            button {
                                display: none;
                            }
                        }
                    </style>
                </head>
                <body>
                    <h2>Tenancy Payment Details</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Payment Date</th>
                                <th style="text-align: right;">Total Amount</th>
                                <th style="text-align: right;">Credit Card</th>
                                <th style="text-align: right;">Cash</th>
                                <th style="text-align: right;">Other</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowsHTML}
                            <tr class="totals-row">
                                <td colspan="2" style="text-align: right;">TOTALS:</td>
                                <td style="text-align: right; font-weight: bold;">$${totalAmount.toFixed(2)}</td>
                                <td style="text-align: right;">$${totalCreditCard.toFixed(2)}</td>
                                <td style="text-align: right;">$${totalCash.toFixed(2)}</td>
                                <td style="text-align: right;">$${totalOther.toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="totals">
                        <p><strong>Total Received Amount:</strong> $${totalAmount.toFixed(2)}</p>
                    </div>
                    <button onclick="window.print()" style="padding: 10px 20px; margin-top: 20px; cursor: pointer;">Print</button>
                </body>
            </html>
        `;

        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
    };

    useEffect(() => {
        if (tenancyDetailsProps) {
            setTenancyDetails(preProcessData(tenancyDetailsProps));
        } else {
            if (longTermTenancyId) {
                getTenancyInfoByLTTI(longTermTenancyId);
            }
        }
    }, [tenancyDetailsProps, longTermTenancyId]);

    const getTenancyInfoByLTTI = async (longTermTenancyId) => {
        try {
            await axios.get(`${url}/payments/getAllPaymentsByLLTI/${longTermTenancyId}`).then((responseForPaymentDetails) => {
                console.log(responseForPaymentDetails.data);
                setTenancyDetails(preProcessData(responseForPaymentDetails.data));
            });
        } catch (error) {
            console.log(error);
        }
    };

    const preProcessData = (tenancyDetailsProps) => {
        const payments = tenancyDetailsProps.payments;
        const tenancyDetails = tenancyDetailsProps.tenancyDetails;
        let resultArray = [];
        let totalReceived = 0;
        
        for (let itr in payments) {
            const currentTenancyDetails = tenancyDetails[itr];
            for (let jtr in payments[itr]) {
                const current = payments[itr][jtr];
                var temp = 0;
                let amountPaid = 0;
                if (current.cashAmount !== null) {
                    temp += current.cashAmount;
                } 
                if (current.creditCardAmount !== null) {
                    temp += current.creditCardAmount;
                } 
                if (current.otherAmount !== null) {
                    temp += current.otherAmount;
                }
                amountPaid += temp;
                totalReceived += amountPaid;

                resultArray.push({
                    ...payments[itr][jtr],
                    ...tenancyDetails[itr], 
                    amountPaid: amountPaid
                });
            }
        }
        
        setTotalAmountPaid(totalReceived);
        
        console.log(resultArray);
        return resultArray;
    };

    const columns = [
        {
          field:"receiptNumber",
          headerName:"Receipt Number",
          width:120,
        },
        { 
            field: 'paymentDate', 
            headerName: 'Payment Date', 
            width: 200, 
            align: 'left',
            renderCell: (params) => {
                return formatDateText(params.row.actualPaymentDate);
            }
        },
        { 
            field: 'amountPaid', 
            headerName: 'Total Amount', 
            width: 150, 
            align: 'left',
            renderCell: (params) => {
                runningBalance -= params.row.amountPaid;
                return <b><NumericFormat value={params.row.amountPaid} 
                    thousandSeparator prefix={'$'} displayType="text"/></b>;
            }
        },
        { 
            field: 'creditCardAmount', 
            headerName: 'Credit Card Amount', 
            width: 150, 
            align: 'left',
            renderCell: (params) => {
                runningBalance -= params.row.creditCardAmount;
                return <NumericFormat value={params.row.creditCardAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/>;
            }
        },
        { 
            field: 'cashAmount', 
            headerName: 'Cash Amount', 
            width: 150, 
            align: 'left',
            renderCell: (params) => {
                runningBalance -= params.row.cashAmount;
                return <NumericFormat value={params.row.cashAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/>;
            }
        },
        { 
            field: 'otherAmount', 
            headerName: 'Other Amount', 
            width: 150, 
            align: 'left',
            renderCell: (params) => {
                runningBalance -= params.row.otherAmount;
                return <NumericFormat value={params.row.otherAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/>;
            }
        },
        {
          field:"paidBy",
          headerName:"Paid By",
          width:150,
        },
        
    ];

    function CustomPagination(props) {
        return (
            <>
                <b>Total Received Amount: 
                    <NumericFormat 
                        value={totalAmountPaid} 
                        fixedDecimalScale={true} 
                        decimalScale={2}
                        thousandSeparator 
                        prefix={'$'} 
                        displayType="text"
                    />
                </b>
                <GridPagination {...props} />
            </>
        );
    }

    return (
        <>
            <Dialog
                open={showTenancyDetailsByLTTIModal}
                onClose={handleCloseTenancyDetailsByLTTIPopup}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle> 
                    Tenancy Payment Details
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    </DialogContentText>
                    <Box
                        sx={{
                            height: 400,
                            width: '97%',
                            marginLeft: '1.5%',
                            '& .actions': {
                                color: 'text.secondary',
                            },
                            '& .textPrimary': {
                                color: 'text.primary',
                            },
                        }}
                    >
                        <DataGrid 
                            rows={tenancyDetails} 
                            columns={columns}
                            getRowId={(row) => row.paymentId}
                            slots={{
                                pagination: CustomPagination,
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={handlePrint} 
                        startIcon={<PrintIcon />} 
                        variant="contained" 
                        color="primary"
                    >
                        Print All
                    </Button>
                    <Button onClick={handleCloseTenancyDetailsByLTTIPopup}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TenancyDetailsByLTTI;